import PhotoSwipe from "photoswipe"

window.PhotoSwipe = PhotoSwipe
